function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M203.09 338.728c36.375 0 56.776-6.803 68.804-12.435 2.275-4.305 0-17.207 0-17.207l-140.336-3.843s-3.728 5.303-3.728 18.07c10.194 7.105 40.718 15.415 75.26 15.415",
  fill: "#0079BF"
}), React.createElement("path", {
  d: "M203.982 280.67c88.835 0 126.482 12.346 126.482 12.346.203.14-.788-1.691-.788-24.199 0-32.34-6.777-46.162-9.312-58.265-10.62-50.733-58.237-89.707-118.858-89.707-51.136 0-94.781 27.777-112.077 66.894l-.117-.145s-20.215 42.76-20.215 105.387c18.386-14.732 46.052-12.312 134.885-12.312",
  fill: "#81929C"
}), React.createElement("path", {
  d: "M187.939 155.197c-10.4-5.933-19.823-6.385-19.823-6.385l18.634-8.448s-9.897-3.75-19.808 2.965c15.65-19.512 33.899-22.453 34.387-22.482-51.064.069-94.627 27.822-111.9 66.89l-.116-.145S69.097 230.354 69.097 292.98c8.016-6.427 17.802-9.587 33.65-11.111l98.126-89.706s-15.581-27.085-12.934-36.967",
  fill: "#576D7A"
}), React.createElement("path", {
  d: "M83.356 291.325l-4.752 11.788s20.449-5.684 34.465 0c11.369 4.613 28.68 20.706 87.804 20.185 59.124-.517 93.43-19.43 102.344-20.189 8.911-.763 16.089.004 16.089.004l-4.8-10.138 15.958.041s-2.014-10.994-8.562-32.01c-6.216-19.947-25.44-23.94-35.529-21.54 20.408-47.303-18.889-74.389-44.16-74.389-17.911 0-34.108 9.046-41.34 27.087-9.392-19.955-23.546-26.811-41.456-26.811-25.269 0-64.77 26.81-44.164 74.253-11.57-.927-25.21 3.419-34.867 21.4-8.12 21.056-11.289 31.975-11.289 31.975l14.26-1.656z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M330.325 292.941c-11.408-14.633-35.749-17.473-65.608-9.612-24.938 6.565-19.056 21.673-62.732 21.809-43.674.128-42.368-28.123-88.324-28.115-14.296.005-31.65 2.203-44.459 14.964-.068.634-.104.993-.104.993l14.259-1.655-4.752 11.788s20.448-5.684 34.464 0c11.37 4.613 28.681 20.706 87.804 20.185 59.125-.517 93.431-19.43 102.344-20.189 8.912-.763 16.09.004 16.09.004l-4.8-10.138 15.818-.034z",
  fill: "#E1E4E6"
}), React.createElement("path", {
  d: "M223.92 269.544c0 6.51-2.146 16.078-23.352 16.078-20.667 0-23.35-9.568-23.35-16.078 0-6.52 3.755-11.798 23.35-11.798 20.668 0 23.351 5.278 23.351 11.798",
  fill: "#333"
}), React.createElement("path", {
  d: "M170.902 211.744c0-10.612-6.14-19.22-13.699-19.22-7.569 0-13.706 8.608-13.706 19.22 0 10.613 6.137 12.796 13.706 12.796 7.56-.001 13.699-2.183 13.699-12.796",
  fill: "#0079BF"
}), React.createElement("path", {
  d: "M166.12 209.162c0-4.865-3.987-8.805-8.907-8.805s-8.913 3.94-8.913 8.805c0 4.866 3.993 8.81 8.913 8.81s8.908-3.944 8.908-8.81",
  fill: "#000"
}), React.createElement("path", {
  d: "M160.451 202.534c0 3.314-2.399 5.995-5.35 5.995-2.953 0-5.346-2.68-5.346-5.995 0-3.312 2.393-5.996 5.347-5.996 2.95 0 5.35 2.683 5.35 5.996",
  fill: "#FFF"
}), React.createElement("g", null, React.createElement("path", {
  d: "M257.76 211.744c0-10.612-6.139-19.22-13.698-19.22-7.57 0-13.706 8.608-13.706 19.22 0 10.613 6.137 12.796 13.706 12.796 7.56-.001 13.699-2.183 13.699-12.796",
  fill: "#0079BF"
}), React.createElement("path", {
  d: "M252.98 209.162c0-4.865-3.988-8.805-8.908-8.805s-8.914 3.94-8.914 8.805c0 4.866 3.994 8.81 8.914 8.81s8.908-3.944 8.908-8.81",
  fill: "#000"
}), React.createElement("path", {
  d: "M247.31 202.534c0 3.314-2.4 5.995-5.35 5.995-2.953 0-5.346-2.68-5.346-5.995 0-3.312 2.393-5.996 5.346-5.996 2.95 0 5.35 2.683 5.35 5.996",
  fill: "#FFF"
})), React.createElement("g", null, React.createElement("path", {
  d: "M159.931 280.538s5.492 52.136 38.787 55.824c42.899 4.747 46.758-56.485 46.758-56.485s-15.84 27.254-43.491 25.262c-27.65-1.996-42.054-24.6-42.054-24.6",
  fill: "#333"
}), React.createElement("path", {
  d: "M173.084 295.565l-1.13 33.676c.629 14.235 13.645 28.475 29.65 28.475 16.008 0 29.023-14.24 29.65-28.475l1.25-34.377c-7.13 3.38-19.092 5.526-30.602 5.526-10.709 0-19.31-1.848-28.818-4.825",
  fill: "#FFD2D5"
}), React.createElement("path", {
  d: "M193.68 349.015c-17.003-5.335-13.823-38.337-11.936-51.044a135.141 135.141 0 0 1-8.66-2.401l-1.13 33.667c.629 14.24 13.645 28.48 29.65 28.48 9.598 0 18.093-5.13 23.515-12.303-6.52 4.51-16.849 8.181-31.439 3.601",
  fill: "#E8AFB4"
}), React.createElement("path", {
  d: "M201.902 300.39c-10.71 0-19.31-1.848-28.82-4.824l-.455 13.587c4.744 3.54 13.632 10.81 28.02 14.154-2.825-12.29-6.765-20.175-6.765-20.175h15.432s1.993 8.177-.008 18.978c11.012-2.419 18.138-7.707 22.679-12.935l.519-14.31c-7.13 3.38-19.092 5.525-30.602 5.525",
  fill: "#E8AFB4"
}), React.createElement("path", {
  d: "M200.647 323.307c1.057 4.59 1.96 9.778 2.444 15.421 3.417-5.742 5.265-11.477 6.22-16.62a57.685 57.685 0 0 1-8.438 1.19c-.08.009-.145.005-.226.009",
  fill: "#E8AFB4"
}), React.createElement("path", {
  d: "M209.315 303.13h-15.432s3.94 7.886 6.764 20.177c.082-.004.148 0 .226-.009a57.565 57.565 0 0 0 8.434-1.188c2.001-10.802.008-18.98.008-18.98",
  fill: "#D1868F"
}), React.createElement("path", {
  d: "M249.668 271.685c-2.973 13.645-17.164 31.446-47.683 33.453-29.848 1.962-48.088-23.197-48.088-35.826 0 0 13.046 31.107 48.005 31.078 34.963-.025 47.766-28.705 47.766-28.705",
  fill: "#333"
})), React.createElement("g", null, React.createElement("path", {
  d: "M185.553 125.726c-22.236-54.907-58.172-83.371-64.986-82.714-6.817.66-23.162 35.806-31.293 77.835-6.963 36.014 3.043 73.583 3.043 73.583",
  fill: "#576D7A"
}), React.createElement("path", {
  d: "M153.875 119.625c4.498-13.868-20.534-65.47-31.262-67.54-7.21-1.386-17.729 27.403-26.116 66.618-8.395 39.214.064 61.913.064 61.913s3.809-28.227 24.77-42.34c20.967-14.113 28.05-4.787 32.544-18.65",
  fill: "#BEC7CC"
}), React.createElement("path", {
  d: "M150.699 115.682c-.163 7.326-19.077 7.003-34.95 18.33 4.486-14.614 14.807-16.71 14.807-16.71s-12.446-5.423-17.345-12.315c4.865-1.812 16.46 1.645 16.46 1.645s-9.23-6.007-10.84-21.864c9.128 1.138 12.735 11.472 12.735 11.472s-7.064-16.6.306-26.043c2.996 4.137 19.085 33.613 18.827 45.485",
  fill: "#D5DBDE"
})), React.createElement("g", null, React.createElement("path", {
  d: "M217.539 125.726c22.24-54.907 58.172-83.371 64.988-82.714 6.812.66 23.16 35.806 31.287 77.835 6.97 36.014-3.043 73.583-3.043 73.583",
  fill: "#81929C"
}), React.createElement("path", {
  d: "M249.216 119.625c-4.498-13.868 20.534-65.47 31.262-67.54 7.213-1.386 17.727 27.403 26.123 66.618 8.389 39.214-1.326 54.826-1.326 54.826s-2.551-21.14-23.517-35.252c-20.958-14.114-28.041-4.788-32.542-18.652",
  fill: "#D5DBDE"
}), React.createElement("path", {
  d: "M252.397 115.682c.159 7.326 19.074 7.003 34.942 18.33-4.483-14.614-14.804-16.71-14.804-16.71s12.45-5.423 17.343-12.315c-4.863-1.812-16.456 1.645-16.456 1.645s9.23-6.007 10.834-21.864c-9.123 1.138-12.727 11.472-12.727 11.472s7.064-16.6-.313-26.043c-2.994 4.137-19.079 33.613-18.82 45.485",
  fill: "#F0F2F3"
})));

var SvgTrelloTaco = function SvgTrelloTaco(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrelloTaco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trello-taco.941f4a18.svg";
export { ForwardRef as ReactComponent };